var exports = {
  "k": "xa15a2ab7--cc4273--container",
};

module.exports = exports;
